// src/lib/utils.ts

import {type ClassValue, clsx} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function validateEmail(value: string): boolean {
  return value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i) !== null
}

export function parseMapString(mapString: string): {
  [key: string]: string | boolean
} {
  const result: {[key: string]: string | boolean} = {}

  // Check that the string has the expected format
  if (mapString.startsWith("map[") && mapString.endsWith("]")) {
    // Remove the prefix and suffix
    const content = mapString.substring(4, mapString.length - 1)

    const tokens = content.split(" ")
    let currentKey: string | null = null
    let buffer: string[] = []

    const commit = () => {
      if (currentKey !== null) {
        const rawValue = buffer.join(" ")
        if (rawValue === "true") {
          result[currentKey] = true
        } else if (rawValue === "false") {
          result[currentKey] = false
        } else {
          result[currentKey] = rawValue
        }
      }
      currentKey = null
      buffer = []
    }

    tokens.forEach((token) => {
      if (token.includes(":")) {
        // New key encountered — commit previous one if any
        commit()
        const [key, firstValPart] = token.split(":", 2)
        currentKey = key
        buffer.push(firstValPart)
      } else {
        // Part of the current value
        buffer.push(token)
      }
    })

    // Commit the last collected key/value pair
    commit()
  }

  return result
}
